import React from 'react';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import About from '../components/About';
import Ventures from '../components/Ventures';
import Innovation from '../components/Innovation';
import Impact from '../components/Impact';
import News from '../components/News';
import ServicesTeaser from '../components/ServicesTeaser';

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <About />
      <div id="products">
        <Ventures />
      </div>
      <ServicesTeaser />
      <Innovation />
      <Impact />
      <News />
    </>
  );
}
